import {all, fork} from 'redux-saga/effects'
import rootCoachDashboardsagas from './dashboard/rootCoachDashboardsagas'
import rootOnBoardingSagas from './onBoarding/rootOnBoardingSagas'
export default function* rootCoachSagas() {
  yield all([ 
    rootOnBoardingSagas(),
    rootCoachDashboardsagas(),
   
  ])
}